var map = {
	"./activity/ACIO.svg": 8,
	"./activity/BPCR_ACT.svg": 9,
	"./activity/CAMV_ACT.svg": 10,
	"./activity/CAV_ACT.svg": 11,
	"./activity/DBS_ACT.svg": 12,
	"./activity/DT_ACT.svg": 13,
	"./activity/ECEP_ACT.svg": 14,
	"./activity/EMOActivity.svg": 15,
	"./activity/IEDExplosion_ACT.svg": 16,
	"./activity/IED_ACT.svg": 17,
	"./activity/INFL_ACT.svg": 18,
	"./activity/ISF_ACT.svg": 19,
	"./activity/LAB_ACT.svg": 20,
	"./activity/MISO_ACT.svg": 21,
	"./activity/OM_ACT.svg": 22,
	"./activity/PIED_ACT.svg": 23,
	"./activity/UXO_ACT.svg": 24,
	"./activity/arrest.svg": 25,
	"./activity/assassinationVictim.svg": 26,
	"./activity/attemptedCriminalActivity.svg": 27,
	"./activity/blackMarket_ACT.svg": 28,
	"./activity/bombExplosion_ACT.svg": 29,
	"./activity/bombThreat_ACT.svg": 30,
	"./activity/bombing.svg": 31,
	"./activity/boobyTrap.svg": 32,
	"./activity/burglary_ACT.svg": 33,
	"./activity/drugs.svg": 34,
	"./activity/election.svg": 35,
	"./activity/emergencyMedicalOperation.svg": 36,
	"./activity/execution_ACT.svg": 37,
	"./activity/exfiltrationActivity.svg": 38,
	"./activity/explosion_ACT.svg": 39,
	"./activity/extortion_ACT.svg": 40,
	"./activity/fireArson_ACT.svg": 41,
	"./activity/fireEvent_ACT.svg": 42,
	"./activity/fireHotSpot_ACT.svg": 43,
	"./activity/fireOrigin_ACT.svg": 44,
	"./activity/foragingForFood_ACT.svg": 45,
	"./activity/gang_ACT.svg": 46,
	"./activity/graffiti_ACT.svg": 47,
	"./activity/grenadeExplosion_ACT.svg": 48,
	"./activity/hijacking_ACT.svg": 49,
	"./activity/homeEviction_ACT.svg": 50,
	"./activity/house_ACT.svg": 51,
	"./activity/individual_ACT.svg": 52,
	"./activity/isolatedPersonnelActivity.svg": 53,
	"./activity/jailbreak_ACT.svg": 54,
	"./activity/kidnapping_ACT.svg": 55,
	"./activity/massDemonstration.svg": 56,
	"./activity/meeting_ACT.svg": 57,
	"./activity/mineExplosion_ACT.svg": 58,
	"./activity/mortarExplosion_ACT.svg": 59,
	"./activity/murderVictim_ACT.svg": 60,
	"./activity/patrolling_ACT.svg": 61,
	"./activity/piracy_ACT.svg": 62,
	"./activity/poisoning_ACT.svg": 63,
	"./activity/raidOnHome_ACT.svg": 64,
	"./activity/rape_ACT.svg": 65,
	"./activity/riot_ACT.svg": 66,
	"./activity/robbery_ACT.svg": 67,
	"./activity/rock_ACT.svg": 68,
	"./activity/rocketExplosion_ACT.svg": 69,
	"./activity/sabotage_ACT.svg": 70,
	"./activity/school_ACT.svg": 71,
	"./activity/searchingOrForaging.svg": 72,
	"./activity/shooting_ACT.svg": 73,
	"./activity/smuggling_ACT.svg": 74,
	"./activity/sniping_ACT.svg": 75,
	"./activity/spying_ACT.svg": 76,
	"./activity/theft_ACT.svg": 77,
	"./activity/triage_ACT.svg": 78,
	"./activity/warrant_ACT.svg": 79,
	"./amplifiers/CTCP.svg": 80,
	"./amplifiers/EECP.svg": 81,
	"./amplifiers/FTCP.svg": 82,
	"./amplifiers/RAR.svg": 83,
	"./amplifiers/TFBTF.svg": 84,
	"./amplifiers/TFCT.svg": 85,
	"./amplifiers/TFMEF.svg": 86,
	"./amplifiers/reduced.svg": 87,
	"./amplifiers/reinforced.svg": 88,
	"./echelon/army.svg": 89,
	"./echelon/armyGroup.svg": 90,
	"./echelon/brigade.svg": 91,
	"./echelon/command.svg": 92,
	"./echelon/corps.svg": 93,
	"./echelon/division.svg": 94,
	"./echelon/platoon.svg": 95,
	"./echelon/regiment.svg": 96,
	"./echelon/section.svg": 97,
	"./echelon/squad.svg": 98,
	"./echelon/squadron.svg": 99,
	"./echelon/teamOrCrew.svg": 100,
	"./echelon/theatre.svg": 101,
	"./echelon/troop.svg": 102,
	"./equipment/ADGG.svg": 103,
	"./equipment/ADGMR.svg": 104,
	"./equipment/ADGSR.svg": 105,
	"./equipment/ADML_G.svg": 106,
	"./equipment/ADML_LR.svg": 107,
	"./equipment/ADML_SR.svg": 108,
	"./equipment/AHIF.svg": 109,
	"./equipment/ATGG.svg": 110,
	"./equipment/ATGH.svg": 111,
	"./equipment/ATGL.svg": 112,
	"./equipment/ATGM.svg": 113,
	"./equipment/ATHRV.svg": 114,
	"./equipment/ATML_G.svg": 115,
	"./equipment/ATML_LR.svg": 116,
	"./equipment/ATML_MR.svg": 117,
	"./equipment/ATML_SR.svg": 118,
	"./equipment/ATRL_G.svg": 119,
	"./equipment/ATRL_LR.svg": 120,
	"./equipment/ATRL_MR.svg": 121,
	"./equipment/ATRL_SR.svg": 122,
	"./equipment/AWC.svg": 123,
	"./equipment/BTAE.svg": 124,
	"./equipment/C2AFV.svg": 125,
	"./equipment/CBRN_EQ.svg": 126,
	"./equipment/CHIF.svg": 127,
	"./equipment/CMS.svg": 128,
	"./equipment/DFGG.svg": 129,
	"./equipment/DFGH.svg": 130,
	"./equipment/DFGL.svg": 131,
	"./equipment/DFGM.svg": 132,
	"./equipment/FWA_F.svg": 133,
	"./equipment/FWA_G.svg": 134,
	"./equipment/FWA_IF_HOSTILE.svg": 135,
	"./equipment/FWA_IF_NEUTRAL.svg": 136,
	"./equipment/FWA_IF_UNKNOWN.svg": 137,
	"./equipment/GLG.svg": 138,
	"./equipment/GLLR.svg": 139,
	"./equipment/GLMR.svg": 140,
	"./equipment/GLSR.svg": 141,
	"./equipment/HIC_H.svg": 142,
	"./equipment/HIC_L.svg": 143,
	"./equipment/HIC_M.svg": 144,
	"./equipment/HMWUV.svg": 145,
	"./equipment/HOWITZERG.svg": 146,
	"./equipment/HOWITZERH.svg": 147,
	"./equipment/HOWITZERL.svg": 148,
	"./equipment/HOWITZERM.svg": 149,
	"./equipment/HOWITZERVH.svg": 150,
	"./equipment/MEHIF.svg": 151,
	"./equipment/MG_G.svg": 152,
	"./equipment/MG_H.svg": 153,
	"./equipment/MG_L.svg": 154,
	"./equipment/MG_M.svg": 155,
	"./equipment/ML_G.svg": 156,
	"./equipment/ML_LR.svg": 157,
	"./equipment/ML_ML.svg": 158,
	"./equipment/ML_SR.svg": 159,
	"./equipment/MNCS.svg": 160,
	"./equipment/MRL_G.svg": 161,
	"./equipment/MRL_LR.svg": 162,
	"./equipment/MRL_MR.svg": 163,
	"./equipment/MRL_SR.svg": 164,
	"./equipment/RATVWHATG.svg": 165,
	"./equipment/RWA_F.svg": 166,
	"./equipment/RWA_G.svg": 167,
	"./equipment/RWA_IF_HOSTILE.svg": 168,
	"./equipment/RWA_IF_NEUTRAL.svg": 169,
	"./equipment/RWA_IF_UNKNOWN.svg": 170,
	"./equipment/S2_AMP.svg": 171,
	"./equipment/S2_AT.svg": 172,
	"./equipment/S2_HEAVY.svg": 173,
	"./equipment/S2_LAUNCHER.svg": 174,
	"./equipment/S2_LIGHT.svg": 175,
	"./equipment/S2_MEDIUM.svg": 176,
	"./equipment/S2_PA.svg": 177,
	"./equipment/S2_RAIL.svg": 178,
	"./equipment/S2_TT.svg": 179,
	"./equipment/S2_UASL.svg": 180,
	"./equipment/S2_WHMCC.svg": 181,
	"./equipment/S2_WLM.svg": 182,
	"./equipment/SRL_G.svg": 183,
	"./equipment/SRL_LR.svg": 184,
	"./equipment/SRL_MR.svg": 185,
	"./equipment/SRL_SR.svg": 186,
	"./equipment/SSML_G.svg": 187,
	"./equipment/SSML_LR.svg": 188,
	"./equipment/SSML_MR.svg": 189,
	"./equipment/SSML_SR.svg": 190,
	"./equipment/TM_AMP.svg": 191,
	"./equipment/TM_BARGE.svg": 192,
	"./equipment/TM_OS.svg": 193,
	"./equipment/TM_PA.svg": 194,
	"./equipment/TM_RAILWAY.svg": 195,
	"./equipment/TM_SKI.svg": 196,
	"./equipment/TM_SLED.svg": 197,
	"./equipment/TM_TOSP.svg": 198,
	"./equipment/TM_TOWED.svg": 199,
	"./equipment/TM_WAT.svg": 200,
	"./equipment/TM_WCC.svg": 201,
	"./equipment/TM_WL.svg": 202,
	"./equipment/UAS_F.svg": 203,
	"./equipment/UAS_G.svg": 204,
	"./equipment/airDefenseGun_LR.svg": 205,
	"./equipment/airDefenseML_MR.svg": 206,
	"./equipment/armoredFightingVehicle.svg": 207,
	"./equipment/armoredPersonnelCarrier.svg": 208,
	"./equipment/armoredProtectedVehicle.svg": 209,
	"./equipment/bridge_Fixed.svg": 210,
	"./equipment/bridge_G.svg": 211,
	"./equipment/bridge_Girder.svg": 212,
	"./equipment/bridge_Hollow.svg": 213,
	"./equipment/bus.svg": 214,
	"./equipment/civilianShip_POL.svg": 215,
	"./equipment/combatTrains.svg": 216,
	"./equipment/commoSat.svg": 217,
	"./equipment/computer.svg": 218,
	"./equipment/drill.svg": 219,
	"./equipment/earthmover.svg": 220,
	"./equipment/earthmover_MF.svg": 221,
	"./equipment/flameThrower.svg": 222,
	"./equipment/flatbedRailwayCar.svg": 223,
	"./equipment/generator_EQ.svg": 224,
	"./equipment/laser_EQ.svg": 225,
	"./equipment/mineClearingEq.svg": 226,
	"./equipment/mineLayingEq.svg": 227,
	"./equipment/mortar_G.svg": 228,
	"./equipment/mortar_H.svg": 229,
	"./equipment/mortar_L.svg": 230,
	"./equipment/mortar_M.svg": 231,
	"./equipment/nonLethal.svg": 232,
	"./equipment/psyops_EQ.svg": 233,
	"./equipment/radar_EQ.svg": 234,
	"./equipment/railwayBoxcar.svg": 235,
	"./equipment/recoiless_G.svg": 236,
	"./equipment/recoiless_H.svg": 237,
	"./equipment/recoiless_L.svg": 238,
	"./equipment/recoiless_M.svg": 239,
	"./equipment/rifle_G.svg": 240,
	"./equipment/rifle_H.svg": 241,
	"./equipment/rifle_L.svg": 242,
	"./equipment/rifle_M.svg": 243,
	"./equipment/sensor_EQ.svg": 244,
	"./equipment/tank_G.svg": 245,
	"./equipment/tank_H.svg": 246,
	"./equipment/tank_L.svg": 247,
	"./equipment/tank_M.svg": 248,
	"./equipment/taser.svg": 249,
	"./equipment/trainOrLocomotive.svg": 250,
	"./equipment/unspecifiedWeapon.svg": 251,
	"./equipment/vehicle.svg": 252,
	"./equipment/waterCannon.svg": 253,
	"./example_symbols/E1.svg": 254,
	"./example_symbols/E10.svg": 255,
	"./example_symbols/E11.svg": 256,
	"./example_symbols/E12.svg": 257,
	"./example_symbols/E2.svg": 258,
	"./example_symbols/E3.svg": 259,
	"./example_symbols/E4.svg": 260,
	"./example_symbols/E5.svg": 261,
	"./example_symbols/E6.svg": 262,
	"./example_symbols/E7.svg": 263,
	"./example_symbols/E8.svg": 264,
	"./example_symbols/E9.svg": 265,
	"./gcm/FPOL.svg": 266,
	"./gcm/OB_DIFFICULT.svg": 267,
	"./gcm/OB_EASY.svg": 268,
	"./gcm/OB_IMPOSSIBLE.svg": 269,
	"./gcm/OP_CBRN.svg": 270,
	"./gcm/OP_COMBAT.svg": 271,
	"./gcm/OP_FORWARD.svg": 272,
	"./gcm/OP_GENERIC.svg": 273,
	"./gcm/OP_RECON.svg": 274,
	"./gcm/OP_SENSOR.svg": 275,
	"./gcm/RIP.svg": 276,
	"./gcm/RPOL.svg": 277,
	"./gcm/SARPoint.svg": 278,
	"./gcm/SPC1.svg": 279,
	"./gcm/SPC10.svg": 280,
	"./gcm/SPC1NATO.svg": 281,
	"./gcm/SPC2.svg": 282,
	"./gcm/SPC3.svg": 283,
	"./gcm/SPC3NATO.svg": 284,
	"./gcm/SPC4.svg": 285,
	"./gcm/SPC4NATO.svg": 286,
	"./gcm/SPC5.svg": 287,
	"./gcm/SPC6.svg": 288,
	"./gcm/SPC7.svg": 289,
	"./gcm/SPC8.svg": 290,
	"./gcm/SPC9.svg": 291,
	"./gcm/SPMSCP.svg": 292,
	"./gcm/TRP.svg": 293,
	"./gcm/abatis.svg": 294,
	"./gcm/aboveGroundFacility.svg": 295,
	"./gcm/acpPoint.svg": 296,
	"./gcm/airborneAoA.svg": 297,
	"./gcm/airfieldPoint.svg": 298,
	"./gcm/ambush.svg": 299,
	"./gcm/apMine.svg": 300,
	"./gcm/apMineWithDirFX.svg": 301,
	"./gcm/arpPoint.svg": 302,
	"./gcm/aspPoint.svg": 303,
	"./gcm/atDitch.svg": 304,
	"./gcm/atDitchComplete.svg": 305,
	"./gcm/atDitchWithATMines.svg": 306,
	"./gcm/atMine.svg": 307,
	"./gcm/atMineWithAHDev.svg": 308,
	"./gcm/athpPoint.svg": 309,
	"./gcm/attackByFire.svg": 310,
	"./gcm/attackHelicopterAoA.svg": 311,
	"./gcm/aviationDirectionOfAttack.svg": 312,
	"./gcm/axpPoint.svg": 313,
	"./gcm/block.svg": 314,
	"./gcm/boobyTrapMine.svg": 315,
	"./gcm/bridgeMobility.svg": 316,
	"./gcm/canPoint.svg": 317,
	"./gcm/ccpPoint.svg": 318,
	"./gcm/checkpoint.svg": 319,
	"./gcm/contactPoint.svg": 320,
	"./gcm/controlpoint.svg": 321,
	"./gcm/cordonAndKnock.svg": 322,
	"./gcm/cordonAndSearch.svg": 323,
	"./gcm/counterattack.svg": 324,
	"./gcm/cover.svg": 325,
	"./gcm/decisionPoint.svg": 326,
	"./gcm/deconPoint.svg": 327,
	"./gcm/delay.svg": 328,
	"./gcm/demonstration.svg": 329,
	"./gcm/directionOfMainAttack.svg": 330,
	"./gcm/disrupt.svg": 331,
	"./gcm/encirclementOps.svg": 332,
	"./gcm/engineerRegulatingPoint.svg": 333,
	"./gcm/feint.svg": 334,
	"./gcm/ferry.svg": 335,
	"./gcm/fightingPosition.svg": 336,
	"./gcm/finalProtectiveFires.svg": 337,
	"./gcm/fireSupportStation.svg": 338,
	"./gcm/fix.svg": 339,
	"./gcm/fordDifficult.svg": 340,
	"./gcm/fordEasy.svg": 341,
	"./gcm/fort.svg": 342,
	"./gcm/fortifiedArea.svg": 343,
	"./gcm/fortifiedLine.svg": 344,
	"./gcm/gap.svg": 345,
	"./gcm/groupOfTargets.svg": 346,
	"./gcm/guard.svg": 347,
	"./gcm/isoPoint.svg": 348,
	"./gcm/keyTerrain.svg": 349,
	"./gcm/linearSmokeTarget.svg": 350,
	"./gcm/linearTarget.svg": 351,
	"./gcm/lrpPoint.svg": 352,
	"./gcm/mainAoA.svg": 353,
	"./gcm/mcpPoint.svg": 354,
	"./gcm/medevacPoint.svg": 355,
	"./gcm/minefield_ap.svg": 356,
	"./gcm/minefield_apwdfx.svg": 357,
	"./gcm/minefield_at.svg": 358,
	"./gcm/minefield_atah.svg": 359,
	"./gcm/minefield_cluster.svg": 360,
	"./gcm/minefield_unspecified.svg": 361,
	"./gcm/minefield_waat.svg": 362,
	"./gcm/mortuaryAffairsPoint.svg": 363,
	"./gcm/nuclearTarget.svg": 364,
	"./gcm/obstacleLine.svg": 365,
	"./gcm/passageLane.svg": 366,
	"./gcm/pointOfInterest.svg": 367,
	"./gcm/pointTarget.svg": 368,
	"./gcm/r3pPoint.svg": 369,
	"./gcm/rallyPoint.svg": 370,
	"./gcm/releasePoint.svg": 371,
	"./gcm/retirement.svg": 372,
	"./gcm/screen.svg": 373,
	"./gcm/shelter.svg": 374,
	"./gcm/spGenPoint.svg": 375,
	"./gcm/startPoint.svg": 376,
	"./gcm/strongPoint.svg": 377,
	"./gcm/supportByFire.svg": 378,
	"./gcm/targetHandover.svg": 379,
	"./gcm/tcpPoint.svg": 380,
	"./gcm/tripwireMine.svg": 381,
	"./gcm/ttpPoint.svg": 382,
	"./gcm/turn.svg": 383,
	"./gcm/undergroundFacility.svg": 384,
	"./gcm/unspecifiedMine.svg": 385,
	"./gcm/waatMine.svg": 386,
	"./gcm/waypoint.svg": 387,
	"./gcm/wireObstacle.svg": 388,
	"./gcm/wireObstacleSingleFence.svg": 389,
	"./gcm/wireObstacleSingleStrandConcertina.svg": 390,
	"./gcm/withdraw.svg": 391,
	"./gcm/withdrawUnderPressure.svg": 392,
	"./installation/APAF.svg": 393,
	"./installation/APF_IN.svg": 394,
	"./installation/BPF.svg": 395,
	"./installation/BTA.svg": 396,
	"./installation/CBRNDECON_IN.svg": 397,
	"./installation/CBRNFacility.svg": 398,
	"./installation/CGF.svg": 399,
	"./installation/CSF_IN.svg": 400,
	"./installation/DOJ_IN.svg": 401,
	"./installation/DPRE_IN.svg": 402,
	"./installation/EGCPF_IN.svg": 403,
	"./installation/EGF.svg": 404,
	"./installation/EGGT_IN.svg": 405,
	"./installation/EGPOL_IN.svg": 406,
	"./installation/EMOOPS_IN.svg": 407,
	"./installation/EMS_IN.svg": 408,
	"./installation/GO_IN.svg": 409,
	"./installation/MTF_IN.svg": 410,
	"./installation/PMF.svg": 411,
	"./installation/SRF_IN.svg": 412,
	"./installation/TTSF_IN.svg": 413,
	"./installation/airportFacility.svg": 414,
	"./installation/ammoFacility.svg": 415,
	"./installation/building_IN.svg": 416,
	"./installation/college_IN.svg": 417,
	"./installation/fireFighterFacility.svg": 418,
	"./installation/foodStorage_IN.svg": 419,
	"./installation/grenadeCache.svg": 420,
	"./installation/hospital_IN.svg": 421,
	"./installation/law_IN.svg": 422,
	"./installation/massGrave_IN.svg": 423,
	"./installation/policeTraining_IN.svg": 424,
	"./installation/rawMaterialMine_IN.svg": 425,
	"./main/AFS.svg": 426,
	"./main/ANGLICO.svg": 427,
	"./main/ATF.svg": 428,
	"./main/CA.svg": 429,
	"./main/CBRN.svg": 430,
	"./main/CBRNHYE.svg": 431,
	"./main/CBRNRecon.svg": 432,
	"./main/DEA.svg": 433,
	"./main/EOD.svg": 434,
	"./main/Engineer.svg": 435,
	"./main/FBI.svg": 436,
	"./main/Finance.svg": 437,
	"./main/HR.svg": 438,
	"./main/ISF.svg": 439,
	"./main/JAG.svg": 440,
	"./main/KS.svg": 441,
	"./main/MISO.svg": 442,
	"./main/MP.svg": 443,
	"./main/Maintenance.svg": 444,
	"./main/Medical.svg": 445,
	"./main/NATOLiaison.svg": 446,
	"./main/PS.svg": 447,
	"./main/Public-Affairs.svg": 448,
	"./main/SAR.svg": 449,
	"./main/SEAL.svg": 450,
	"./main/SF.svg": 451,
	"./main/SOF.svg": 452,
	"./main/Signal.svg": 453,
	"./main/Space-Unit.svg": 454,
	"./main/Special-Troops.svg": 455,
	"./main/airAndMissileDefense.svg": 456,
	"./main/airDefense.svg": 457,
	"./main/airRecon.svg": 458,
	"./main/ammo.svg": 459,
	"./main/antiArmorAntiTank.svg": 460,
	"./main/armoredRecon.svg": 461,
	"./main/armoredTrackUnit.svg": 462,
	"./main/band.svg": 463,
	"./main/cavalry.svg": 464,
	"./main/chaplain.svg": 465,
	"./main/civilMilitaryCooperation.svg": 466,
	"./main/combinedArms.svg": 467,
	"./main/fieldArtillery.svg": 468,
	"./main/fireProtection.svg": 469,
	"./main/fixedWingAviation.svg": 470,
	"./main/infantry.svg": 471,
	"./main/informationOperations.svg": 472,
	"./main/interpreterTranslator.svg": 473,
	"./main/isolatedPersonnel.svg": 474,
	"./main/lawEnforcementAgency.svg": 475,
	"./main/maneuverEnhancement.svg": 476,
	"./main/mechanizedArmoredInfantry.svg": 477,
	"./main/medicalTreatmentFacility.svg": 478,
	"./main/militaryIntelligence.svg": 479,
	"./main/missile.svg": 480,
	"./main/missileDefense.svg": 481,
	"./main/mobileGunSystem.svg": 482,
	"./main/mortarUnit.svg": 483,
	"./main/mortuaryAffairs.svg": 484,
	"./main/ordnance.svg": 485,
	"./main/policeDepartment.svg": 486,
	"./main/quartermaster.svg": 487,
	"./main/ranger.svg": 488,
	"./main/rigger.svg": 489,
	"./main/rotaryWingAviation.svg": 490,
	"./main/securityISF.svg": 491,
	"./main/support.svg": 492,
	"./main/surveillance.svg": 493,
	"./main/sustainment.svg": 494,
	"./main/transportation.svg": 495,
	"./main/usMarshalls.svg": 496,
	"./main/usss.svg": 497,
	"./sector1/AWS.svg": 498,
	"./sector1/C2.svg": 499,
	"./sector1/CBRNArea.svg": 500,
	"./sector1/CCC.svg": 501,
	"./sector1/CI.svg": 502,
	"./sector1/CID.svg": 503,
	"./sector1/CPN.svg": 504,
	"./sector1/CRC.svg": 505,
	"./sector1/CYB.svg": 506,
	"./sector1/EO.svg": 507,
	"./sector1/EOS.svg": 508,
	"./sector1/EOSA.svg": 509,
	"./sector1/EOSB.svg": 510,
	"./sector1/EOSC.svg": 511,
	"./sector1/EOSCorps.svg": 512,
	"./sector1/EOSD.svg": 513,
	"./sector1/EOSIS.svg": 514,
	"./sector1/EOST.svg": 515,
	"./sector1/EPP.svg": 516,
	"./sector1/EW.svg": 517,
	"./sector1/FDC.svg": 518,
	"./sector1/HIMARS.svg": 519,
	"./sector1/HQ.svg": 520,
	"./sector1/JNN.svg": 521,
	"./sector1/MAS.svg": 522,
	"./sector1/MEDEVAC.svg": 523,
	"./sector1/MET.svg": 524,
	"./sector1/MISI.svg": 525,
	"./sector1/MN.svg": 526,
	"./sector1/MR1.svg": 527,
	"./sector1/MR2.svg": 528,
	"./sector1/MR3.svg": 529,
	"./sector1/MR4.svg": 530,
	"./sector1/MS.svg": 531,
	"./sector1/MTS.svg": 532,
	"./sector1/NO.svg": 533,
	"./sector1/PLS.svg": 534,
	"./sector1/POL.svg": 535,
	"./sector1/RTNS.svg": 536,
	"./sector1/TA.svg": 537,
	"./sector1/UAS.svg": 538,
	"./sector1/airfield.svg": 539,
	"./sector1/assaultHeli.svg": 540,
	"./sector1/attackHeli.svg": 541,
	"./sector1/aviationMaintenance.svg": 542,
	"./sector1/biological.svg": 543,
	"./sector1/bridging.svg": 544,
	"./sector1/chemical.svg": 545,
	"./sector1/combat.svg": 546,
	"./sector1/combatCamera.svg": 547,
	"./sector1/composite.svg": 548,
	"./sector1/construction.svg": 549,
	"./sector1/decontamination.svg": 550,
	"./sector1/detention.svg": 551,
	"./sector1/digitalSignal.svg": 552,
	"./sector1/diving.svg": 553,
	"./sector1/dog.svg": 554,
	"./sector1/drilling.svg": 555,
	"./sector1/enhancedSignal.svg": 556,
	"./sector1/forwardSPT.svg": 557,
	"./sector1/generalEngineering.svg": 558,
	"./sector1/geospatialInformation.svg": 559,
	"./sector1/intermodal.svg": 560,
	"./sector1/jamming.svg": 561,
	"./sector1/maintenancePLT.svg": 562,
	"./sector1/mod1Mortar.svg": 563,
	"./sector1/mod1SAR.svg": 564,
	"./sector1/nuclear.svg": 565,
	"./sector1/operations.svg": 566,
	"./sector1/ordnanceEOD.svg": 567,
	"./sector1/pipeline.svg": 568,
	"./sector1/postal.svg": 569,
	"./sector1/radar.svg": 570,
	"./sector1/radiological.svg": 571,
	"./sector1/railway.svg": 572,
	"./sector1/riverine.svg": 573,
	"./sector1/satellite.svg": 574,
	"./sector1/sensor.svg": 575,
	"./sector1/singleRocketLauncher.svg": 576,
	"./sector1/sniper.svg": 577,
	"./sector1/stryker.svg": 578,
	"./sector1/survey.svg": 579,
	"./sector1/utility.svg": 580,
	"./sector1/water.svg": 581,
	"./sector1/watercraft.svg": 582,
	"./sector1/weapons.svg": 583,
	"./sector2/CBRNDECON.svg": 584,
	"./sector2/COMP.svg": 585,
	"./sector2/COSC.svg": 586,
	"./sector2/LAB.svg": 587,
	"./sector2/LC.svg": 588,
	"./sector2/MA.svg": 589,
	"./sector2/MHA.svg": 590,
	"./sector2/MIMR.svg": 591,
	"./sector2/MOD2Riverine.svg": 592,
	"./sector2/MOD2SFA.svg": 593,
	"./sector2/MOD2Search.svg": 594,
	"./sector2/MOD2Supply.svg": 595,
	"./sector2/MOD2Support.svg": 596,
	"./sector2/MOD2Towed.svg": 597,
	"./sector2/OGTB.svg": 598,
	"./sector2/SCY.svg": 599,
	"./sector2/SDDC.svg": 600,
	"./sector2/SR.svg": 601,
	"./sector2/TH.svg": 602,
	"./sector2/VET.svg": 603,
	"./sector2/VH.svg": 604,
	"./sector2/VTOL.svg": 605,
	"./sector2/WGV.svg": 606,
	"./sector2/WHM.svg": 607,
	"./sector2/YB.svg": 608,
	"./sector2/airborneInfantry.svg": 609,
	"./sector2/amphibiousInfantry.svg": 610,
	"./sector2/analysis.svg": 611,
	"./sector2/armoredTracked.svg": 612,
	"./sector2/bloodSupport.svg": 613,
	"./sector2/control.svg": 614,
	"./sector2/dentalServices.svg": 615,
	"./sector2/directionFinding.svg": 616,
	"./sector2/guerilla.svg": 617,
	"./sector2/heavy.svg": 618,
	"./sector2/highAltitude.svg": 619,
	"./sector2/light.svg": 620,
	"./sector2/lightAndMedium.svg": 621,
	"./sector2/longRange.svg": 622,
	"./sector2/lowAltitude.svg": 623,
	"./sector2/medicalBed.svg": 624,
	"./sector2/medium.svg": 625,
	"./sector2/mountain.svg": 626,
	"./sector2/multifunctional.svg": 627,
	"./sector2/optometry.svg": 628,
	"./sector2/overSnow.svg": 629,
	"./sector2/packAnimal.svg": 630,
	"./sector2/preventativeMedicine.svg": 631,
	"./sector2/railway.svg": 632,
	"./sector2/recovery.svg": 633,
	"./sector2/recoveryMaint.svg": 634,
	"./sector2/ski.svg": 635,
	"./sector2/sled.svg": 636,
	"./sector2/surgical.svg": 637,
	"./tmt/breach.svg": 638,
	"./tmt/bypass.svg": 639,
	"./tmt/canalize.svg": 640,
	"./tmt/clear.svg": 641,
	"./tmt/contain.svg": 642,
	"./tmt/destroy.svg": 643,
	"./tmt/disengage.svg": 644,
	"./tmt/exfiltrate.svg": 645,
	"./tmt/followAndAssume.svg": 646,
	"./tmt/followAndSupport.svg": 647,
	"./tmt/interdict.svg": 648,
	"./tmt/isolate.svg": 649,
	"./tmt/neutralize.svg": 650,
	"./tmt/occupy.svg": 651,
	"./tmt/retain.svg": 652,
	"./tmt/secure.svg": 653,
	"./tmt/seize.svg": 654,
	"./tmt/suppress.svg": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;